import styled from 'styled-components';
import { mediaQuery } from '../../../utils';

export const MeasurementSettingsSidebarStyled = styled.div`
  ${mediaQuery.tabletToUp(`
    padding: 20px;
    width: calc(425px - (20px * 2));
  `)}
`;
